import { formatPhoneNumber } from '@/lib/utilities'

/**
 * Formats a tenant support/SMS number for on-screen copy.
 * Short codes (under 10 digits) stay as-is; longer numbers use national formatting.
 * Keep the raw API value for `sms:` hrefs and open-SMS actions.
 */
export function formatSupportPhoneForDisplay(phoneNumber: string): string {
    const digits = phoneNumber.replace(/\D/g, '')
    if (digits.length < 10) return phoneNumber.trim()
    return formatPhoneNumber(phoneNumber)
}
